import React from 'react';
import { Box, Typography, Tooltip, Paper } from '@mui/material';
import { useGameData } from '../context/GameProvider';

function sectionColor(health: number): string {
  if (health >= 80) return 'success.light';
  if (health >= 60) return 'warning.light';
  return 'error.light';
}

function sectionBorderColor(health: number): string {
  if (health >= 80) return 'success.main';
  if (health >= 60) return 'warning.main';
  return 'error.main';
}

const FortressMap: React.FC = () => {
  const { fortressStatus } = useGameData();

  if (!fortressStatus || !fortressStatus.customer_walls?.length) {
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No customer walls to display.
        </Typography>
      </Box>
    );
  }

  const walls = fortressStatus.customer_walls;

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Fortress Map
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
        Each section represents a customer wall. Color indicates health.
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: (theme) => `repeat(auto-fill, minmax(${theme.spacing(15)}, 1fr))`,
          gap: 1,
        }}
      >
        {walls.map((wall) => (
          <Tooltip
            key={wall.customer_id}
            title={`${wall.customer_name}: ${wall.health_score}% health, ${wall.active_quest_count} quests`}
          >
            <Paper
              elevation={0}
              sx={{
                p: 1.5,
                bgcolor: sectionColor(wall.health_score),
                border: 2,
                borderColor: sectionBorderColor(wall.health_score),
                borderRadius: 1,
                cursor: 'default',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="caption"
                fontWeight="medium"
                noWrap
                sx={{ display: 'block' }}
              >
                {wall.customer_name}
              </Typography>
              <Typography variant="body2" fontWeight="bold">
                {wall.health_score}%
              </Typography>
              {wall.aging_task_count > 0 && (
                <Typography variant="caption" color="error.main">
                  {wall.aging_task_count} aging
                </Typography>
              )}
            </Paper>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default FortressMap;
